'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { logEvent } from '@/containers/AnalyticsContainer';
import { Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { useGetLoginLink } from '@/userStatus/hooks';

export const AnonymousUserDisplay: FC = () => {
  const { push } = useRouter();

  const { loginLink } = useGetLoginLink();

  const handleUserDisplayClick = () => {
    push(loginLink);
    logEvent('ExpModeA_AppBar_click_login');
  };

  return (
    <button
      className="flex cursor-pointer items-center justify-center gap-x-1 rounded-lg bg-white p-3 md:bg-neutral-filled-tertiary-enabled md:p-2 lg:w-full"
      id="ExpModeA_AppBar_click_login"
      onClick={handleUserDisplayClick}
    >
      <Icon
        className="md:!hidden lg:!inline-block"
        color="green-30"
        icon="profile_outline"
        size={24}
      />
      <Text
        className="text-sm font-demibold sm:font-medium md:text-xs"
        color="blue"
        component="span"
      >
        ورود | ثبت‌نام
      </Text>
    </button>
  );
};
